import React,{useState} from 'react'
import Display from './Display'
import { useStateValue } from './StateProvider'
import './ShibuCord_main.css'
import Send from './Send';
function ShibuCord_main() {
    const [{ user },dispatch]= useStateValue();
    return (
        <div className="sc_main">
            <h1>Welcome To shibuCord() {user?.displayName}</h1>
            <Display />
            <Send />
        </div>
    )
}

export default ShibuCord_main
